import { render, staticRenderFns } from "./ActionCommentWidget.vue?vue&type=template&id=007c878e"
import script from "./ActionCommentWidget.vue?vue&type=script&lang=js"
export * from "./ActionCommentWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports